import { GelRowLayout, GelColumnLayout, GelBoxLayout, GelIcon, GelTooltip } from '@tal-gel/components';
import { formatDateTime } from '../Shared/Text';
import { get, isEmpty } from 'lodash';
import { defaultH3Text, brandColour, boldLabel, coverDetailLayout, coverDetailEvenRow, coverDetailOddRow, iconTextAlign, flex } from '../Shared/Styles';
import { useEffect } from 'react';

export default function CoverDetails(props) {
    const policyLife = props.insuredParty;
    var policyStatus =  get(props.policyDetails, 'policy.status', '');
    var sourceSystemCode = get(props.policies, '[0].sourceSystemCode', '');
    var isHybridPremium = false;

    const coverTypeCodes = {
        "life": ["coverName", "coverStatusName", "commencementDate", "sumInsured", "premiumTypeName", "indexation", "installmentPremium", "annualPremium", "stampDuty", "expiryDate"],
        "li": ["coverName", "coverStatusName", "commencementDate", "sumInsured", "premiumTypeName", "indexation", "installmentPremium", "annualPremium", "expiryDate"],
        "wol+end": ["coverName", "coverStatusName", "commencementDate", "sumInsured", "premiumTypeName", "indexation", "installmentPremium", "annualPremium", "stampDuty", "expiryDate"],
        "wo": ["coverName", "coverStatusName", "commencementDate", "sumInsured", "premiumTypeName", "indexation", "installmentPremium", "annualPremium", "stampDuty", "expiryDate"],
        "other": ["coverName", "coverStatusName", "commencementDate", "sumInsured", "premiumTypeName", "indexation", "installmentPremium", "annualPremium", "stampDuty", "expiryDate"],
        "ot": ["coverName", "coverStatusName", "commencementDate", "sumInsured", "premiumTypeName", "indexation", "installmentPremium", "annualPremium", "stampDuty", "expiryDate"],
        "invest": ["coverName", "coverStatusName", "commencementDate", "sumInsured", "premiumTypeName", "indexation", "installmentPremium", "annualPremium", "stampDuty", "expiryDate"],
        "tpd": ["coverName", "coverStatusName", "commencementDate", "sumInsured", "premiumTypeName", "indexation", "installmentPremium", "annualPremium", "stampDuty", "expiryDate", "tpD_Definition"],
        "tp": ["coverName", "coverStatusName", "commencementDate", "sumInsured", "premiumTypeName", "indexation", "installmentPremium", "annualPremium", "stampDuty", "expiryDate", "tpD_Definition"],
        "trauma": ["coverName", "coverStatusName", "commencementDate", "sumInsured", "premiumTypeName", "indexation", "installmentPremium", "annualPremium", "stampDuty", "expiryDate", "coverTypeCode", "coverLevelName"],
        "tr": ["coverName", "coverStatusName", "commencementDate", "sumInsured", "premiumTypeName", "indexation", "installmentPremium", "annualPremium", "stampDuty", "expiryDate", "coverTypeCode", "coverLevelName"],
        "ip+bus": ["coverName", "coverStatusName", "commencementDate", "monthlyIncomeBenefit", "premiumTypeName", "indexation", "installmentPremium", "annualPremium", "stampDuty", "expiryDate", "coverTypeCode", "ipContractTypeName", "coverLevelName", "accidentBenefitPeriod", "accidentWaitingPeriod", "sicknessBenefitPeriod", "sicknessWaitingPeriod"],
        "ip": ["coverName", "coverStatusName", "commencementDate", "monthlyIncomeBenefit", "premiumTypeName", "premiumTypeName", "indexation", "installmentPremium", "annualPremium", "expiryDate", "coverTypeCode", "ipContractTypeName", "accidentBenefitPeriod", "accidentWaitingPeriod", "sicknessBenefitPeriod", "sicknessWaitingPeriod"],
        "i": ["coverName", "coverStatusName", "commencementDate", "monthlyIncomeBenefit", "premiumTypeName", "indexation", "installmentPremium", "annualPremium", "stampDuty", "expiryDate", "coverTypeCode", "ipContractTypeName", "coverLevelName", "accidentBenefitPeriod", "accidentWaitingPeriod", "sicknessBenefitPeriod", "sicknessWaitingPeriod"],
        "unknown": ["coverName", "coverStatusName", "commencementDate", "sumInsured", "monthlyIncomeBenefit", "premiumTypeName", "indexation", "installmentPremium", "annualPremium", "stampDuty", "expiryDate", "tpD_Definition", "coverTypeCode", "ipContractTypeName", "coverLevelName"],
        "bex": ["coverName", "coverStatusName", "commencementDate", "monthlyIncomeBenefit", "premiumTypeName", "indexation",  "installmentPremium", "annualPremium", "expiryDate", "ipContractTypeName", "accidentBenefitPeriod", "accidentWaitingPeriod", "sicknessBenefitPeriod", "sicknessWaitingPeriod"],
        "bo": ["coverName", "coverStatusName", "commencementDate", "monthlyIncomeBenefit", "premiumTypeName", "indexation",  "installmentPremium", "annualPremium", "expiryDate", "ipContractTypeName", "accidentBenefitPeriod", "accidentWaitingPeriod", "sicknessBenefitPeriod", "sicknessWaitingPeriod"],
        "chil": ["coverName", "coverStatusName", "commencementDate", "sumInsured", "premiumTypeName", "installmentPremium", "annualPremium", "expiryDate", "indexation"],
        "ipo": ["coverName", "coverStatusName", "commencementDate", "installmentPremium", "annualPremium", "expiryDate", "indexation"],
        "kpi": ["coverName", "coverStatusName", "commencementDate", "monthlyIncomeBenefit","premiumTypeName", "indexation",  "installmentPremium", "annualPremium", "expiryDate", "ipContractTypeName", "accidentBenefitPeriod", "accidentWaitingPeriod", "sicknessBenefitPeriod", "sicknessWaitingPeriod"],
        "lio": ["coverName", "coverStatusName", "commencementDate", "installmentPremium", "annualPremium", "expiryDate"],
        "ndl": ["coverName", "coverStatusName", "commencementDate", "sumInsured", "premiumTypeName", "installmentPremium", "annualPremium", "expiryDate"],
        "rec": ["coverName", "coverStatusName", "commencementDate", "sumInsured", "premiumTypeName", "indexation", "installmentPremium", "annualPremium", "expiryDate"],
        "tpdo": ["coverName", "coverStatusName", "commencementDate", "installmentPremium", "annualPremium", "expiryDate"],
        "trm": ["coverName", "coverStatusName", "commencementDate", "sumInsured", "premiumTypeName", "indexation", "installmentPremium", "annualPremium", "expiryDate"],
        "trmo": ["coverName", "coverStatusName", "commencementDate", "installmentPremium", "annualPremium", "expiryDate"],
    };

    const displayLabels = {
        "coverStatusName": "Benefit Status",
        "commencementDate": "Benefit Commencement Date",
        "conthlyIncomeBenefit": "Monthly Benefit",
        "sumInsured": "Sum Insured",
        "premiumTypeName":"Premium Type",
        "indexation": "Indexation",
        "installmentPremium": "Instalment Premium",
        "annualPremium": "Annual Premium",
        "stampDuty": "Stamp Duty",
        "expiryDate": "Benefit Expiry Date",
        "ipContractTypeName": "Type of Cover",
        "coverLevelName": "Level of Cover",
        "tpD_Definition": "TPD Definition",
        "accidentBenefitPeriod": "Benefit Period - Accident",
        "accidentWaitingPeriod": "Waiting Period - Accident",
        "sicknessBenefitPeriod": "Benefit Period - Sickness",
        "sicknessWaitingPeriod": "Waiting Period - Sickness",
    };

    var coverDetails = [];

    const init = () => {
        if (!props.coverDetails || isEmpty(props.coverDetails)) {
            coverDetails = [0];
        } else {
            loadCoverDetails();
        }
    };

    var sourceSystemValue = "";

    const loadCoverDetails = () => {
 
        props.coverDetails.sort((a, b) => a.coverTypeCode > b.coverTypeCode ? 1 : -1);        
        props.coverDetails.forEach(c => {
            if (c.lifeNo === policyLife.lifeNo) {
                var currentCoverDetail = {};
                var currentTypeCodes = [];

                var expriyDateItem = ''; // keep ExpiryDate to the last row

                var coverTypeField = "";

                sourceSystemValue = c.sourceSystem;

                if (c.coverTypeCode && coverTypeCodes.hasOwnProperty(c.coverTypeCode.toLowerCase())) {
                    currentTypeCodes = coverTypeCodes[c.coverTypeCode.toLowerCase()];
                }     
                else {
                    currentTypeCodes = coverTypeCodes.unknown;
                }


                for (var coverTypeCodeIndex in currentTypeCodes) {

                    coverTypeField = currentTypeCodes[coverTypeCodeIndex];
                    if (c[coverTypeField] !== null && coverTypeField === "commencementDate") {
                        currentCoverDetail[coverTypeField] = formatDateTime(c[coverTypeField]);
                    } else if (c[coverTypeField] !== null && coverTypeField === "expiryDate") {
                        expriyDateItem = formatDateTime(c[coverTypeField]);
                    } else if (c[coverTypeField] !== null && (coverTypeField === "monthlyIncomeBenefit" ||
                        coverTypeField === "installmentPremium" ||
                        coverTypeField === "sumInsured" ||
                        coverTypeField === "stampDuty" ||
                        coverTypeField === "annualPremium")) {
                        currentCoverDetail[coverTypeField] = "$" + c[coverTypeField].toLocaleString("en-AU", {
                            minimumFractionDigits: 2
                          });
                    } else {
                        currentCoverDetail[coverTypeField] = c[coverTypeField];
                    }           
                }

                currentCoverDetail["expiryDate"] = expriyDateItem;
                if (policyStatus === 'In Force') {
                  if (c.coverStatusName === 'In Force') {
                        coverDetails.push(currentCoverDetail);
                    }
                }
                else {
                coverDetails.push(currentCoverDetail);
                }
            }
        });
    };

    const coverDetailJSX = (coverDetail) => {
        var result = [];
        var count = 0;        
        for (var key in coverDetail) {
            if (coverDetail.hasOwnProperty(key) && key !== "coverName" && // CoverName is displayed in title, not table.
                key !== "coverTypeCode" && // Doesn't display CoverTypeCode. 
                !(key === "coverTypeCode" && coverDetail.coverTypeCode && coverDetail.coverTypeCode === "Trauma") && // Trauma doesn't display CoverTypeCode.
                !(key === "ipContractTypeName" && (coverDetail.ipContractTypeName === null || coverDetail.ipContractTypeName === "Unknown")) && // don't display covertype if it is unknow or null.
                !((key === "stampDuty" || key === "tpD_Definition") && sourceSystemValue === "CLO") && // don't display "Stamp Duty" for TLIS/CLO policies           
                !(key === "coverLevelName" && coverDetail.coverTypeCode && coverDetail.coverTypeCode === "Trauma" && coverDetail.coverName.indexOf("Child") >= 0) && // Child's Truma doesn't display "Level of Cover"
                !(key === "coverLevelName" && coverDetail.coverTypeCode &&
                    (coverDetail.coverTypeCode.toLowerCase() === "ip+bus" || coverDetail.coverTypeCode.toLowerCase() === "i" || coverDetail.coverTypeCode.toLowerCase() === "ip") && 
                    (coverDetail.coverLevelName === null || coverDetail.coverLevelName === "Unknown")) // don't display "Level of Cover" if it is unknow or null for Income protection
            ) {
                if (((key === "sicknessBenefitPeriod" || key === "accidentBenefitPeriod") && coverDetail["accidentBenefitPeriod"] === coverDetail["sicknessBenefitPeriod"]) ||
                    ((key === "sicknessWaitingPeriod" || key === "accidentWaitingPeriod") && coverDetail["accidentWaitingPeriod"] === coverDetail["sicknessWaitingPeriod"])) {
                    // don't display duplicate Benefit and Waiting Period if Sickness and Accident have same value.

                    if (key === "sicknessBenefitPeriod" || key === "sicknessWaitingPeriod") {
                        result.push(<GelRowLayout key={key} gutter="medium" style={(count % 2 === 0) ? coverDetailEvenRow : coverDetailOddRow}>
                            <GelColumnLayout distribution="1/2 1/2">
                                <div>{displayLabels[key].split("-")[0]}</div>
                                <div data-testid={key}>{coverDetail[key]}</div>
                            </GelColumnLayout>
                        </GelRowLayout>);

                        count++;
                    }
                } else if ((sourceSystemValue === "CLO") && (key==="installmentPremium" || key === "annualPremium"))  {
                    result.push(<GelRowLayout key={key} gutter="medium" style={(count % 2 === 0) ? coverDetailEvenRow : coverDetailOddRow}>
                        <GelColumnLayout distribution="1/2 1/2">
                            <div style={flex}>{displayLabels[key]}<GelTooltip right>
                            Benefit level premiums exclude stamp duty.  If applicable, stamp duty has been applied to the policy level annual premium
                            </GelTooltip></div>
                            <div data-testid={key}>{coverDetail[key]}</div>
                        </GelColumnLayout>
                    </GelRowLayout>);

                    count++;
                }
                
                else {
                    result.push(<GelRowLayout key={key} gutter="medium" style={(count % 2 === 0) ? coverDetailEvenRow : coverDetailOddRow}>
                        <GelColumnLayout distribution="1/2 1/2">
                            <div>{displayLabels[key]}</div>
                            <div data-testid={key}>{coverDetail[key]}</div>
                        </GelColumnLayout>
                    </GelRowLayout>);

                    count++;
                }

            }
        }        
        return (result);
    };

    init(); 

    if(props !== undefined && props.policyDetails !== undefined && props.policyDetails.policy !== undefined && props.policyDetails.policy.hasHybridPremium !== undefined && props.policyDetails.policy.hasHybridPremium === true)
    {
         isHybridPremium = true;
    }

    return (
        <div data-testid="coverDetailsDiv">
            { sourceSystemCode !== undefined && sourceSystemCode.length > 0 && sourceSystemCode.toUpperCase() === "LFH" &&
            <GelRowLayout gutter="medium">
                <GelBoxLayout space="auto" distribution="start" alignment="start">
                    <GelIcon name="AlertCircle" width={30} color={brandColour} float />
                    <div style={iconTextAlign}><span style={boldLabel}>Disclaimer: </span>Benefit options are not displayed on this screen. Please use the Request Policy Documents screen to request a Certificate of Currency or Policy Document, which will contain this information.</div>
                </GelBoxLayout>
            </GelRowLayout>
            }
            {  isHybridPremium &&
                <p style={{ color: 'red' }}>*This policy has a hybrid premium. The premium type on this page may not be accurate. Please refer to the most recent renewal statement for the hybrid premium breakdown</p>
            }

            {coverDetails.map((coverDetail, index) =>

                <div key={index} style={coverDetailLayout}>
                    <GelRowLayout gutter="medium">
                        <h3 data-testid="CoverName" style={defaultH3Text}>{get(coverDetail, 'coverName', '')}</h3>
                    </GelRowLayout>

                    {coverDetailJSX(coverDetail)}

                    <GelRowLayout style={{ padding: '24px 0' }}>
                        {(index !== coverDetails.length - 1) &&
                            <hr />
                        }
                    </GelRowLayout>
                    </div>
            )}

        </div>
    );
}